export const PRODUCT_UPDATE_FORM_ID = Symbol("product-update-form-id");
